import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import blue from '../../ChakraGame/blue.png';
import yellow from '../../ChakraGame/yellow.png';
import green from '../../ChakraGame/green.png';
import * as API from "../../Endpoints/Endpoints"
import { useNavigate } from "react-router-dom";

const MoralSciencePage = () => {
  const chakraRef = useRef(null);
  const navigate = useNavigate();

  const [globalQuestions, setGlobalQuestions] = useState([]);
  const [aiChariotQuestions, setAIChariotQuestions] = useState([]);
  const [randomQuestions, setRandomQuestions] = useState([]);
  const [answers, setAnswers] = useState({});

  const [showQuestions, setShowQuestions] = useState(false);
  const [rotate, setRotate] = useState(true);

  const fetchGlobalEthicsQuestions = async () => {
    try {
      const response = await axios.get(API.GET_GLOBAL_ETHICS_API);
      const questions = response.data.map(item => item.moralsciencequestion);
      setGlobalQuestions(questions);
    } catch (error) {
      console.error("Error fetching Global Ethics questions:", error);
    }
  };

  const fetchAIChariotQuestions = async () => {
    try {
      const response = await axios.get(API.GET_AI_CHARIOT_API);
      const questions = response.data.map(item => item.moralsciencequestion);
      setAIChariotQuestions(questions);
    } catch (error) {
      console.error("Error fetching AI Chariot questions:", error);
    }
  };

  const pickRandomQuestions = () => {
    const combined = [...globalQuestions, ...aiChariotQuestions];
    const shuffled = combined.sort(() => 0.5 - Math.random());
    const selected = shuffled.slice(0, 10);
    setRandomQuestions(selected);
  };

  useEffect(() => {
    fetchGlobalEthicsQuestions();
    fetchAIChariotQuestions();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      pickRandomQuestions();
      setShowQuestions(true);
      setRotate(false); // stop rotation
    }, 10000);

    return () => clearTimeout(timer);
  }, [globalQuestions, aiChariotQuestions]);

  const handleAnswerChange = (index, value) => {
    setAnswers(prev => ({ ...prev, [index]: value }));
  };
  

  return (
    <div className="min-h-screen flex flex-row bg-white px-5 py-5">

      {/* Left Side — Questions */}
      {showQuestions && (
  <div className="flex flex-col w-[45%] pr-5 overflow-y-auto ml-0">
    <button
      className="mb-4 bg-red-600 text-white px-3 py-1 rounded hover:bg-red-800"
      onClick={() => window.location.reload()}
    >
      Refresh
    </button>

    <h2 className="text-2xl font-bold mb-4">Moral Science Questions</h2>

    <ul className="list-decimal pl-5">
      {randomQuestions.map((question, index) => (
        <li key={index} className="mb-4">
          <p className="font-medium">{question}</p>
          <textarea
            rows="1"
            className="w-full border border-gray-300 rounded p-2 mt-2 focus:outline-none focus:ring focus:border-blue-500"
            value={answers[index] || ""}
            onChange={(e) => handleAnswerChange(index, e.target.value)}
            placeholder="Type your answer here..."
          />
        </li>
      ))}
    </ul>

    <button
      className="mt-6 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-800"
      onClick={() => {
        console.log("Submitted Answers: ", answers);
        // You can replace this with API submission logic
      }}
    >
      Submit Answers
    </button>

    <button
      className="mt-4 bg-red-600 text-white px-3 py-1 rounded hover:bg-red-800"
      onClick={() => navigate('/chakramaster')}
    >
      Go Back
    </button>
  </div>
)}

      {/* Right Side — Chakra */}
      <div className="flex-1 flex items-center justify-center relative">
  <div
    ref={chakraRef}
    className={`relative w-[600px] h-[600px] ${rotate ? "animate-multi-spin" : ""}`}
  >
    <img src={yellow} alt="Yellow Chakra" className="absolute top-0 left-0 w-full h-full z-10" />
    <div className="absolute top-1/2 left-1/2 w-[200px] h-[200px] transform -translate-x-1/2 -translate-y-1/2">
      <img src={blue} alt="Blue Chakra" className="w-full h-full" />
    </div>
  </div>
  <div className="absolute top-[calc(40%-40px)] left-1/2 transform -translate-x-1/2 w-[400px] z-20">
    <img src={green} alt="Green Chakra" className="w-full" />
  </div>
</div>

    </div>
  );
};

export default MoralSciencePage;
